<template>
    <LayoutSub>
        <SubSection class="pb-0" v-if="data">
            <div class="post_header">
                <h2>{{ data.recruit?.subject || data.notice?.subject }}</h2>
                <span class="date">{{ new Date(data.recruit?.writeDate ||
                    data.notice?.writeDate).toLocaleDateString('ko-KR') }}</span>
            </div>

            <div class="board_content">
                <div class="board_content_body" v-html="data.recruit?.contents || data.notice?.contents"></div>
                <div class="attach_box" v-if="data.recruit?.filename || data.notice?.filename">
                    <div class="title_area">
                        <img src="@/assets/ic-attach.png" alt="" />
                        <span>첨부파일</span>
                    </div>
                    <div class="file_area">
                        <a :href="`${data.recruit?.filePath || data.notice?.filePath}`"
                            :download="data.recruit?.orgFilename || data.notice?.orgFilename">
                            {{ data.recruit?.orgFilename || data.notice?.orgFilename }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="list_control_wrap">
                <div class="col" v-if="data.recruit?.prevIdx || data.notice?.prevIdx" @click="moveToPost(data.recruit?.prevIdx || data.notice?.prevIdx)">
                    <i class="ic_prev"></i>
                    <span>
                        {{ (data.recruit?.prevSubject || data.notice?.prevSubject)?.slice(0, 24) }}
                        {{ (data.recruit?.prevSubject || data.notice?.prevSubject)?.length > 24 ? '...' : '' }}
                    </span>
                </div>
                <div class="col none_inter" v-else>
                    <i class="ic_prev"></i>
                    <span>이전글이 없습니다.</span>
                </div>
                <div class="col list_button" @click="returnList">
                    <button>
                        <img src="@/assets/ic-list.png" alt="" />
                    </button>
                </div>
                <div class="col" v-if="data.recruit?.nextIdx || data.notice?.nextIdx" @click="moveToPost(data.recruit?.nextIdx || data.notice?.nextIdx)">
                    <span>
                        {{ (data.recruit?.nextSubject || data.notice?.nextSubject)?.slice(0, 24) }}
                        {{ (data.recruit?.nextSubject || data.notice?.nextSubject)?.length > 24 ? '...' : '' }}
                    </span>
                    <i class="ic_next"></i>
                </div>
                <div class="col none_inter" v-else>
                    <span>다음글이 없습니다.</span>
                    <i class="ic_next"></i>
                </div>
            </div>
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>
<script>
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        LoadingWrap,
        SubSection,
    },
    props: {
        data: {
            type: Object,
            default: () => ({ recruit: {}, notice: {} })
        },
    },
    methods: {
        returnList() {
            const targetRoute = this.$route.path.split('/').slice(0, -1).join('/');
            this.$router.push({
                path: targetRoute,
                query: {
                    ...this.$route.query,
                },
            });
        },
        moveToPost(idx) {
            if (!idx) {
                return;
            }

            this.$router.push({
                path: `./${idx}`,
                query: this.$route.query,
            });
        },
    },
};
</script>
